/* tslint:disable */
/* eslint-disable */
/**
 * Modulos Platform API v1
 * API for the Modulos Platform.
 *
 * The version of the OpenAPI document: 2.5.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ErrorResponse } from '../model';
// @ts-ignore
import type { HTTPValidationError } from '../model';
// @ts-ignore
import type { ResponseGetUserUsersUserIdGet } from '../model';
// @ts-ignore
import type { ResponseGetUsersMeUsersMeGet } from '../model';
// @ts-ignore
import type { Roles } from '../model';
// @ts-ignore
import type { SignupLink } from '../model';
// @ts-ignore
import type { UpdateUser } from '../model';
/**
 * UsersApi - axios parameter creator
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete User Roles
         * @param {string} userId 
         * @param {Roles} role 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserRolesUsersUserIdRolesDelete: async (userId: string, role: Roles, projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteUserRolesUsersUserIdRolesDelete', 'userId', userId)
            // verify required parameter 'role' is not null or undefined
            assertParamExists('deleteUserRolesUsersUserIdRolesDelete', 'role', role)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('deleteUserRolesUsersUserIdRolesDelete', 'projectId', projectId)
            const localVarPath = `/users/{user_id}/roles`
                .replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the signup link for a user. Only available for super admins.  Args:     organization (schemas.Organization): The organization the user belongs to     user (schemas.OrganizationUser): The user to get the signup link for     db (Session): Database session  Returns:     SignupLink: The signup link for the user.
         * @summary Get User Signup Link
         * @param {string} userId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserSignupLinkUsersUserIdSignupLinkGet: async (userId: string, organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserSignupLinkUsersUserIdSignupLinkGet', 'userId', userId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getUserSignupLinkUsersUserIdSignupLinkGet', 'organizationId', organizationId)
            const localVarPath = `/users/{user_id}/signup-link`
                .replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (organizationId !== undefined) {
                localVarQueryParameter['organization_id'] = organizationId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the user with the given id.  Args:     user_id (uuid.UUID): The user id.  Returns:     schemas.User: The user with the given id.
         * @summary Get User
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserUsersUserIdGet: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserUsersUserIdGet', 'userId', userId)
            const localVarPath = `/users/{user_id}`
                .replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the current user.  Returns:     schemas.User: The current user.
         * @summary Get Users Me
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersMeUsersMeGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the last access of the user.  Args:     current_user (schemas.User, optional): The current user. Defaults         to Depends(dependencies.get_current_active_user).     db (Session, optional): Database session. Defaults to Depends(get_db).
         * @summary Patch Users Me Last Access
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUsersMeLastAccessUsersMeLastAccessPatch: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/me/last_access`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allows users to update their information.  Args:     user (schemas.UpdateUser): The new user information.     current_user (schemas.User, optional): The current user. Defaults         to Depends(dependencies.get_current_active_user).     db (Session, optional): Database session. Defaults to Depends(get_db).
         * @summary Patch Users Me
         * @param {UpdateUser} updateUser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUsersMeUsersMePatch: async (updateUser: UpdateUser, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateUser' is not null or undefined
            assertParamExists('patchUsersMeUsersMePatch', 'updateUser', updateUser)
            const localVarPath = `/users/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUser, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Post User Roles
         * @param {string} userId 
         * @param {Roles} role 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUserRolesUsersUserIdRolesPost: async (userId: string, role: Roles, projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('postUserRolesUsersUserIdRolesPost', 'userId', userId)
            // verify required parameter 'role' is not null or undefined
            assertParamExists('postUserRolesUsersUserIdRolesPost', 'role', role)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('postUserRolesUsersUserIdRolesPost', 'projectId', projectId)
            const localVarPath = `/users/{user_id}/roles`
                .replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Backward-compat shim for the v2 invitation flow.
         * @summary Resend User Invite
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendUserInviteUsersUserIdResendInvitePost: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('resendUserInviteUsersUserIdResendInvitePost', 'userId', userId)
            const localVarPath = `/users/{user_id}/resend-invite`
                .replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete User Roles
         * @param {string} userId 
         * @param {Roles} role 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUserRolesUsersUserIdRolesDelete(userId: string, role: Roles, projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUserRolesUsersUserIdRolesDelete(userId, role, projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.deleteUserRolesUsersUserIdRolesDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the signup link for a user. Only available for super admins.  Args:     organization (schemas.Organization): The organization the user belongs to     user (schemas.OrganizationUser): The user to get the signup link for     db (Session): Database session  Returns:     SignupLink: The signup link for the user.
         * @summary Get User Signup Link
         * @param {string} userId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserSignupLinkUsersUserIdSignupLinkGet(userId: string, organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignupLink>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserSignupLinkUsersUserIdSignupLinkGet(userId, organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getUserSignupLinkUsersUserIdSignupLinkGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the user with the given id.  Args:     user_id (uuid.UUID): The user id.  Returns:     schemas.User: The user with the given id.
         * @summary Get User
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserUsersUserIdGet(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseGetUserUsersUserIdGet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserUsersUserIdGet(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getUserUsersUserIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the current user.  Returns:     schemas.User: The current user.
         * @summary Get Users Me
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsersMeUsersMeGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseGetUsersMeUsersMeGet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsersMeUsersMeGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getUsersMeUsersMeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates the last access of the user.  Args:     current_user (schemas.User, optional): The current user. Defaults         to Depends(dependencies.get_current_active_user).     db (Session, optional): Database session. Defaults to Depends(get_db).
         * @summary Patch Users Me Last Access
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchUsersMeLastAccessUsersMeLastAccessPatch(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchUsersMeLastAccessUsersMeLastAccessPatch(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.patchUsersMeLastAccessUsersMeLastAccessPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Allows users to update their information.  Args:     user (schemas.UpdateUser): The new user information.     current_user (schemas.User, optional): The current user. Defaults         to Depends(dependencies.get_current_active_user).     db (Session, optional): Database session. Defaults to Depends(get_db).
         * @summary Patch Users Me
         * @param {UpdateUser} updateUser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchUsersMeUsersMePatch(updateUser: UpdateUser, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchUsersMeUsersMePatch(updateUser, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.patchUsersMeUsersMePatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Post User Roles
         * @param {string} userId 
         * @param {Roles} role 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postUserRolesUsersUserIdRolesPost(userId: string, role: Roles, projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postUserRolesUsersUserIdRolesPost(userId, role, projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.postUserRolesUsersUserIdRolesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Backward-compat shim for the v2 invitation flow.
         * @summary Resend User Invite
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendUserInviteUsersUserIdResendInvitePost(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendUserInviteUsersUserIdResendInvitePost(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.resendUserInviteUsersUserIdResendInvitePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UsersApi - factory interface
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete User Roles
         * @param {UsersApiDeleteUserRolesUsersUserIdRolesDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserRolesUsersUserIdRolesDelete(requestParameters: UsersApiDeleteUserRolesUsersUserIdRolesDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteUserRolesUsersUserIdRolesDelete(requestParameters.userId, requestParameters.role, requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the signup link for a user. Only available for super admins.  Args:     organization (schemas.Organization): The organization the user belongs to     user (schemas.OrganizationUser): The user to get the signup link for     db (Session): Database session  Returns:     SignupLink: The signup link for the user.
         * @summary Get User Signup Link
         * @param {UsersApiGetUserSignupLinkUsersUserIdSignupLinkGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserSignupLinkUsersUserIdSignupLinkGet(requestParameters: UsersApiGetUserSignupLinkUsersUserIdSignupLinkGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignupLink> {
            return localVarFp.getUserSignupLinkUsersUserIdSignupLinkGet(requestParameters.userId, requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the user with the given id.  Args:     user_id (uuid.UUID): The user id.  Returns:     schemas.User: The user with the given id.
         * @summary Get User
         * @param {UsersApiGetUserUsersUserIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserUsersUserIdGet(requestParameters: UsersApiGetUserUsersUserIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseGetUserUsersUserIdGet> {
            return localVarFp.getUserUsersUserIdGet(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the current user.  Returns:     schemas.User: The current user.
         * @summary Get Users Me
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersMeUsersMeGet(options?: RawAxiosRequestConfig): AxiosPromise<ResponseGetUsersMeUsersMeGet> {
            return localVarFp.getUsersMeUsersMeGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the last access of the user.  Args:     current_user (schemas.User, optional): The current user. Defaults         to Depends(dependencies.get_current_active_user).     db (Session, optional): Database session. Defaults to Depends(get_db).
         * @summary Patch Users Me Last Access
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUsersMeLastAccessUsersMeLastAccessPatch(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.patchUsersMeLastAccessUsersMeLastAccessPatch(options).then((request) => request(axios, basePath));
        },
        /**
         * Allows users to update their information.  Args:     user (schemas.UpdateUser): The new user information.     current_user (schemas.User, optional): The current user. Defaults         to Depends(dependencies.get_current_active_user).     db (Session, optional): Database session. Defaults to Depends(get_db).
         * @summary Patch Users Me
         * @param {UsersApiPatchUsersMeUsersMePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUsersMeUsersMePatch(requestParameters: UsersApiPatchUsersMeUsersMePatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.patchUsersMeUsersMePatch(requestParameters.updateUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Post User Roles
         * @param {UsersApiPostUserRolesUsersUserIdRolesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUserRolesUsersUserIdRolesPost(requestParameters: UsersApiPostUserRolesUsersUserIdRolesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postUserRolesUsersUserIdRolesPost(requestParameters.userId, requestParameters.role, requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Backward-compat shim for the v2 invitation flow.
         * @summary Resend User Invite
         * @param {UsersApiResendUserInviteUsersUserIdResendInvitePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendUserInviteUsersUserIdResendInvitePost(requestParameters: UsersApiResendUserInviteUsersUserIdResendInvitePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.resendUserInviteUsersUserIdResendInvitePost(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for deleteUserRolesUsersUserIdRolesDelete operation in UsersApi.
 */
export interface UsersApiDeleteUserRolesUsersUserIdRolesDeleteRequest {
    readonly userId: string

    readonly role: Roles

    readonly projectId: string
}

/**
 * Request parameters for getUserSignupLinkUsersUserIdSignupLinkGet operation in UsersApi.
 */
export interface UsersApiGetUserSignupLinkUsersUserIdSignupLinkGetRequest {
    readonly userId: string

    readonly organizationId: string
}

/**
 * Request parameters for getUserUsersUserIdGet operation in UsersApi.
 */
export interface UsersApiGetUserUsersUserIdGetRequest {
    readonly userId: string
}

/**
 * Request parameters for patchUsersMeUsersMePatch operation in UsersApi.
 */
export interface UsersApiPatchUsersMeUsersMePatchRequest {
    readonly updateUser: UpdateUser
}

/**
 * Request parameters for postUserRolesUsersUserIdRolesPost operation in UsersApi.
 */
export interface UsersApiPostUserRolesUsersUserIdRolesPostRequest {
    readonly userId: string

    readonly role: Roles

    readonly projectId: string
}

/**
 * Request parameters for resendUserInviteUsersUserIdResendInvitePost operation in UsersApi.
 */
export interface UsersApiResendUserInviteUsersUserIdResendInvitePostRequest {
    readonly userId: string
}

/**
 * UsersApi - object-oriented interface
 */
export class UsersApi extends BaseAPI {
    /**
     * 
     * @summary Delete User Roles
     * @param {UsersApiDeleteUserRolesUsersUserIdRolesDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteUserRolesUsersUserIdRolesDelete(requestParameters: UsersApiDeleteUserRolesUsersUserIdRolesDeleteRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).deleteUserRolesUsersUserIdRolesDelete(requestParameters.userId, requestParameters.role, requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the signup link for a user. Only available for super admins.  Args:     organization (schemas.Organization): The organization the user belongs to     user (schemas.OrganizationUser): The user to get the signup link for     db (Session): Database session  Returns:     SignupLink: The signup link for the user.
     * @summary Get User Signup Link
     * @param {UsersApiGetUserSignupLinkUsersUserIdSignupLinkGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUserSignupLinkUsersUserIdSignupLinkGet(requestParameters: UsersApiGetUserSignupLinkUsersUserIdSignupLinkGetRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUserSignupLinkUsersUserIdSignupLinkGet(requestParameters.userId, requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the user with the given id.  Args:     user_id (uuid.UUID): The user id.  Returns:     schemas.User: The user with the given id.
     * @summary Get User
     * @param {UsersApiGetUserUsersUserIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUserUsersUserIdGet(requestParameters: UsersApiGetUserUsersUserIdGetRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUserUsersUserIdGet(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the current user.  Returns:     schemas.User: The current user.
     * @summary Get Users Me
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUsersMeUsersMeGet(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUsersMeUsersMeGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the last access of the user.  Args:     current_user (schemas.User, optional): The current user. Defaults         to Depends(dependencies.get_current_active_user).     db (Session, optional): Database session. Defaults to Depends(get_db).
     * @summary Patch Users Me Last Access
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public patchUsersMeLastAccessUsersMeLastAccessPatch(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).patchUsersMeLastAccessUsersMeLastAccessPatch(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allows users to update their information.  Args:     user (schemas.UpdateUser): The new user information.     current_user (schemas.User, optional): The current user. Defaults         to Depends(dependencies.get_current_active_user).     db (Session, optional): Database session. Defaults to Depends(get_db).
     * @summary Patch Users Me
     * @param {UsersApiPatchUsersMeUsersMePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public patchUsersMeUsersMePatch(requestParameters: UsersApiPatchUsersMeUsersMePatchRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).patchUsersMeUsersMePatch(requestParameters.updateUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Post User Roles
     * @param {UsersApiPostUserRolesUsersUserIdRolesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postUserRolesUsersUserIdRolesPost(requestParameters: UsersApiPostUserRolesUsersUserIdRolesPostRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).postUserRolesUsersUserIdRolesPost(requestParameters.userId, requestParameters.role, requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Backward-compat shim for the v2 invitation flow.
     * @summary Resend User Invite
     * @param {UsersApiResendUserInviteUsersUserIdResendInvitePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public resendUserInviteUsersUserIdResendInvitePost(requestParameters: UsersApiResendUserInviteUsersUserIdResendInvitePostRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).resendUserInviteUsersUserIdResendInvitePost(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }
}

